import UserListList from './UserListList.vue';

export { UserListList };

export default {
  UserListList,
};
